export const DOMAIN_HIERARCHY_LIMIT = 3000;

export type DomainTypeOption = {
  value: string;
  label: string;
  description: string;
};

export const DOMAIN_TYPE_OPTIONS: DomainTypeOption[] = [
  {
    value: 'Aggregate',
    label: 'Aggregate',
    description: '이벤트 및 트랜잭션 데이터를 포함하는 온라인 서비스 및 트랜잭션 데이터베이스에 가까운 도메인입니다.',
  },
  {
    value: 'Consumer-aligned',
    label: 'Consumer-aligned',
    description:
      '소스 정렬된 여러 데이터를 수집하고 큐레이션하여 다른 도메인이 소비할 수 있는 집계된 데이터와 데이터 제품(예: 고객 360, 고객 세션 등)을 제공하는 도메인입니다.',
  },
  {
    value: 'Source-aligned',
    label: 'Source-aligned',
    description:
      '다양한 도메인의 데이터 조합의 최종 제품이 비즈니스 사용자나 데이터 시민이 데이터 기반 의사 결정을 위해 사용할 수 있는 사용자 중심 도메인입니다.',
  },
] as const;
